<div class="loading-wrapper">
  <div class="overlapped" fxLayout="row" fxLayoutAlign="center center">

    <ng-container *ngIf="state.isLoading">
      <mat-spinner></mat-spinner>
    </ng-container>

    <ng-container *ngIf="state.hasError">
      <span class="material-icons">error</span>
      <span>Fehler beim Bezug der Daten</span>
    </ng-container>


    <ng-container *ngIf="state.hasNoData">
      <span class="material-icons">warning</span>
      <span>Keine Daten vorhanden</span>
    </ng-container>

  </div>

  <div class="main-content">
    <ng-content></ng-content>
  </div>
</div>
<div>

</div>

